import {
  createComponentAdmin,
  type SchemaTypeHelper,
} from '@backstage-components/base';
import {Type, type Static} from '@sinclair/typebox';

export const reactName = 'Date';
export const name = reactName;
export const description = reactName;

const schema = Type.Object({
  timestamp: Type.String({
    title: 'Date and Time',
    default: '2025-02-25T20:25:20.252Z',
  }),
  showTimeZone: Type.Boolean({
    title: 'Show Time Zone',
    default: true,
  }),
  backgroundColor: Type.String({
    title: 'Background Color',
    default: '#0e0e0e',
  }),
  textColor: Type.String({
    title: 'Text Color',
    default: '#ffffff',
  }),
});

const uiSchema = {
  'ui:groups': {
    'ui:template': 'tabs',
    sections: [
      [
        'Properties',
        [
          {
            'ui:template': 'accordion',
            sections: [
              ['Date Properties', ['timestamp', 'showTimeZone']],
              ['Appearance', ['backgroundColor', 'textColor']],
            ],
          },
        ],
      ],
      [
        'Styling',
        [
          {
            'ui:template': 'accordion',
            sections: [['Custom Styles', ['styleAttr']]],
          },
        ],
      ],
      [
        'Animations',
        [
          {
            'ui:template': 'accordion',
            sections: [['Animations', ['animationStates']]],
          },
        ],
      ],
    ],
  },
  timestamp: {
    'ui:widget': 'date-time',
  },
  textColor: {
    'ui:widget': 'color',
  },
  backgroundColor: {
    'ui:widget': 'color',
  },
};

const defaultFieldData: Static<typeof schema> = {
  timestamp: schema.properties.timestamp.default,
  showTimeZone: schema.properties.showTimeZone.default,
  backgroundColor: schema.properties.backgroundColor.default,
  textColor: schema.properties.textColor.default,
};

const instructions = Type.Union([
  // Intentionally blank
]);

export const ComponentDefinition = createComponentAdmin({
  id: '12e94a9b-7940-40e2-98b2-2add2608db57',
  reactName,
  name,
  category: 'component',
  description,
  defaultFieldData,
  instructions,
  schema,
  slotConfiguration: {},
  slug: reactName,
  uiSchema,
  version: 1,
})
  .withAnimationStates()
  .withStyles()
  .build();

export type SchemaType = SchemaTypeHelper<typeof ComponentDefinition>;
